import { css } from '@emotion/core';
import vars from './vars';
export var wrapper = position => /*#__PURE__*/css("display:inline-flex;align-items:center;justify-content:center;", position === 'right' && "flex-direction: row-reverse;", ";");
export var label = {
  name: "1s26z8e",
  styles: "flex:0 1 auto;"
};
var getLabelPadding = (size, position) => {
  var paddingSpace = size === 'mini' ? '5px' : '10px';
  return /*#__PURE__*/css("+ span{", position === 'right' && "padding-right: ".concat(paddingSpace, ";"), " ", position === 'left' && "padding-left: ".concat(paddingSpace, ";"), "}");
};
export var icon = (size, position) => /*#__PURE__*/css("display:flex;flex:0 0 auto;", getLabelPadding(size, position), " align-items:center;justify-content:center;min-width:", vars.size[size || 'regular'].lineHeight, ";min-height:", vars.size[size || 'regular'].lineHeight, ";");